import React from 'react';
import './TestimonialCardStyleSelector.css';

const cardStyles = [
    {
        id: 'classic',
        name: 'Classic Glass',
        preview: '🔮',
        description: 'Glass morphism with blur effect'
    },
    {
        id: 'elegant',
        name: 'Elegant Shadow',
        preview: '✨',
        description: 'Deep shadows and clean design'
    },
    {
        id: 'minimal',
        name: 'Dark Luxury',
        preview: '🖤',
        description: 'Dark premium with gold accents'
    },
    {
        id: 'floating',
        name: 'Moving Gold',
        preview: '🥇',
        description: 'Animated gold gradient flow'
    },
    {
        id: 'soft',
        name: 'Moving Silver',
        preview: '🥈',
        description: 'Animated silver gradient flow'
    },
    {
        id: 'corporate',
        name: 'Dark Metallic',
        preview: '⚫',
        description: 'Dark metal with shine effects'
    },
    {
        id: 'emerald',
        name: 'Forest Whisper',
        preview: '🌲',
        description: 'Soft forest and nature tones'
    },
    {
        id: 'purple',
        name: 'Lavender Dreams',
        preview: '💜',
        description: 'Soft lavender and gentle purples'
    },
    {
        id: 'copper',
        name: 'Copper Shine',
        preview: '🟤',
        description: 'Moving copper gradient (active only)'
    },
    {
        id: 'square-dark',
        name: 'Square Dark',
        preview: '⬛',
        description: 'Sharp edges, dark theme'
    },
    {
        id: 'square-light',
        name: 'Square Light',
        preview: '⬜',
        description: 'Sharp edges, light theme'
    },
    {
        id: 'outline-only',
        name: 'Outline Only',
        preview: '⭕',
        description: 'Minimalist outline design'
    },
    {
        id: 'text-only',
        name: 'Text Only',
        preview: '📝',
        description: 'No avatar, text focus'
    },
    {
        id: 'initials',
        name: 'Initials',
        preview: 'AB',
        description: 'Initials instead of avatars'
    },
    {
        id: 'minimal-line',
        name: 'Minimal Line',
        preview: '▫️',
        description: 'Thin line separator style'
    },
    {
        id: 'invisible',
        name: 'Invisible',
        preview: '👻',
        description: 'Completely transparent, content only'
    },
    {
        id: 'black-rose',
        name: 'Rose Quartz',
        preview: '🌹',
        description: 'Soft rose and blush tones'
    },
    {
        id: 'black-ocean',
        name: 'Ocean Mist',
        preview: '🌊',
        description: 'Calming ocean and mist colors'
    },
    {
        id: 'black-fire',
        name: 'Warm Earth',
        preview: '🍂',
        description: 'Earthy autumn and clay tones'
    },
    {
        id: 'zen',
        name: 'Zen Minimal',
        preview: '🕯️',
        description: 'Ultra-calm zen aesthetics'
    },
    {
        id: 'lotus',
        name: 'Lotus Bloom',
        preview: '🪷',
        description: 'Sacred lotus with soft pink flow'
    },
    {
        id: 'moonstone',
        name: 'Moonstone',
        preview: '🌙',
        description: 'Mystical moonstone with silver glow'
    },
    {
        id: 'crystal',
        name: 'Crystal Energy',
        preview: '💎',
        description: 'Clear crystal with rainbow light'
    },
    {
        id: 'ruby-elegant',
        name: 'Ruby Elegance',
        preview: '♦️',
        description: 'Sophisticated ruby red luxury'
    },
    {
        id: 'invisible-black',
        name: 'Invisible Black',
        preview: '⚫',
        description: 'Transparent with black text'
    }
];

function TestimonialCardStyleSelector({ selectedStyle, onStyleChange }) {
    return (
        <div className="card-style-selector-container">
            <label className="card-style-selector-label">Testimonial Card Style</label>
            <div className="card-style-selector-grid">
                {cardStyles.map((style) => (
                    <button
                        key={style.id}
                        type="button"
                        className={`card-style-selector-button ${selectedStyle === style.id ? 'selected' : ''}`}
                        onClick={() => onStyleChange(style.id)}
                        title={style.description}
                        data-style={style.id}
                    >
                        <div className="card-style-preview">
                            <span className="card-style-preview-symbol">{style.preview}</span>
                        </div>
                        <span className="card-style-name">{style.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}

export default TestimonialCardStyleSelector;
